import React, { useEffect,useState } from 'react'
import Businessdropdown from '../Business/Businessdropdown'
import ListTable from './ListTable'
import img from "../assets/search.png";
import {useGetbusinessMutation,useGetpostingMutation,useDeletebusinessMutation,useDeletepostMutation} from '../../services/api';
import { toast } from 'react-toastify';
import PostTable from "../posting/PostTable";
import {setBuisnessData} from '../../store/getBusinessSlice'
import {setPostData} from "../../store/getPostingSlice";
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
function Listtabs() {
    const navigator = useNavigate();
    const dispatch=useDispatch();
    const location = useLocation();
    const [deletebusiness]=useDeletebusinessMutation();
    const [deletepost]=useDeletepostMutation();
    const [getbusiness, { isLoading, isError }] = useGetbusinessMutation();
    const [getposting, { isLoading: post_loading, isError:post_error }] = useGetpostingMutation();
    const [listingData, setListingData] = useState(null);
    const [data1, setData1] = useState(null);
    const [B_id, setB_id] = useState(null);
    const [data2, setData2] = useState(null);
    const [postingData, setPostingData] = useState(null);
    const [search, setSearch] = useState('');
    console.log("location",location);
    const [dataType, setDataType] = useState("listing")
    console.log("dataType",dataType);
    const selectBusinessId =(id)=>{
      setB_id(id);
    }
    //delete post
    const deletePost = (id)=>{
      Swal.fire({
        title: 'Are you sure you want to delete?',
      
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          
          deletepost(id)
          .unwrap()
          .then((payload) => {
              toast.success("Post delete successfully");
              getPostingData()
          })
          .catch((error) => {
            toast.success("Somthing went wrong");
           
          });
        } 
      })
        
    }
    const deleteBusiness = (id)=>{
      Swal.fire({
        title: 'Are you sure you want to delete?',
      
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          
          deletebusiness(id)
        .unwrap()
        .then((payload) => {
            toast.success("Business delete successfully");
            getListingData()
  
        })
        .catch((error) => {
          toast.success("Somthing went wrong");
         
        });
        } 
      })
        
    }
    const getListingData = ()=>{
        getbusiness()
      .unwrap()
      .then((payload) => {
        setListingData(payload)
        setData1(payload);
        dispatch(setBuisnessData(payload));

      })
      .catch((error) => {
        toast.success("Somthing went wrong");
       
      });
    }
    const getPostingData = ()=>{
        getposting()
      .unwrap()
      .then((payload) => {
        setPostingData(payload)
        setData2(payload)
        dispatch(setPostData(payload));

      })
      .catch((error) => {
        toast.success("Somthing went wrong");
       
      });
    }
    useEffect(() => {
  
        if(dataType=="listing"  && listingData==null)
        getListingData();
        else if( dataType!="listing"&&postingData==null) getPostingData();
    }, [dataType])
    
    useEffect(() => {
 
        if(dataType=="listing" &&search!=""){
     
            const result = data1.filter((val)=>{
                return val.business_name.toLowerCase().match(search.toLowerCase());
            })
            setListingData(result);
        }
        else if(dataType=="posting" || dataType=="postBuy" &&search!=""){
            const result = data2.filter((val)=>{
                return val.title.toLowerCase().match(search.toLowerCase());
            })
            setPostingData(result);
        }
        else {setListingData(data1) ;setPostingData(data2)};
    }, [search])
    
    return (<>
        <div className='' style={{ width: "100%" }}>
        <div className="row ps-4  search_row mb-4">
                  <div className="col-lg-10 col-md-12 col-sm-12">
                    <div style={{ position: "relative" }}>
                      <input
                        placeholder="Search by Business or Post name..."
                        className="add_search business_search upper_input"
                        value={search}
                        onChange={(e)=>setSearch(e.target.value)}
                      />
                      <img
                        src={img}
                        className="search_img"
                        style={{ top: "14px", left: "14px" }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-4 p-0">
                    <button className="ad_btn business_add" onClick={()=>{navigator('/bioInfo');}}>
                      Add Business
                    </button>
                  </div>
                  {B_id && <button className="ad_btn business_add" onClick={()=>{navigator(`/create/posting/${B_id}`);}}>
                      Add Posting
                    </button>}
                  
                </div>
            <div className='list_tab_div'>
                <div></div>
                <div className=' tab_inner tab_inner1'>
                    <ul className="nav nav-pills " id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button onClick={()=>{setDataType("listing");setB_id(null);}} className=" nav-link active list_tab" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" style={{ color: "#1CAC19", fontSize: "12px" }}>Listings</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button onClick={()=>{setDataType("posting");setB_id(null);}} className="nav-link list_tab" id="pills-profile-tab list_tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" style={{ color: "#1CAC19", fontSize: "12px" }}>Postings</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button onClick={()=>{setDataType("postBuy");setB_id(null);}} className="nav-link list_tab" id="pills-profile-tab " data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" style={{ color: "#1CAC19", fontSize: "12px" }}>Buy & Sell</button>
                        </li>
                    </ul>
                </div>
                <div className='list_dropdown'>
                    <Businessdropdown />
                </div>
            </div>
            <div className="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">{dataType=="listing"?<ListTable selectBusinessId={selectBusinessId} data={listingData} listing={true} delete={deleteBusiness}/>:<PostTable data={postingData} selectBusinessId={selectBusinessId} posting={true} delete={deletePost} dataType={dataType}/>}</div>
 
            </div>
        </div>




    </>

    )
}

export default Listtabs